<template>
    <div>
        <h1 style="font-size: 24px; color: black;">官方帖子</h1>
        <el-card  class="margin-bottom-10"  shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="6">
                        <span > 日期：</span>
                            <el-date-picker
                                v-model="queryData.timeDate"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="timestamp">
                            </el-date-picker>
                </el-col>

                <el-col :span="5">
                        <span> 关联游戏: </span>
                        <el-select v-model="queryData.gameId"   clearable filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in gameSelectorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="4">
                        <span >话题:</span>
                        <el-select v-model="queryData.topicName"  clearable  filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in topics"
                                :key="item.id"
                                :label="item.text"
                                :value="item.text">
                            </el-option>
                        </el-select>
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                        <span >账户昵称:</span>
                        <el-input v-model="queryData.officialNickName" style="width: 200px" clearable></el-input>
                </el-col>
                
                <el-col :span="5">
                        <span >关键字:</span>
                        <el-input v-model="queryData.text" style="width: 200px" clearable></el-input>
                </el-col>
                <el-col :span="5">
                        <span >是否有图片:</span>
                        <el-select v-model="queryData.isPic"  clearable  filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in BooleanOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="5">
                        <span >是否有视频:</span>
                        <el-select v-model="queryData.isVideo"  clearable  filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in BooleanOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="8">
                    <el-button class="sub-sub" type="primary"  @click="searchPosts">查询</el-button>
                    <el-button class="sub-sub" type="primary" @click="handleEdit('新增官方贴')" >新增官方贴</el-button>       
                </el-col>
            </el-row>
        </el-card>
        <div>
            <el-table
                    border
                    :fit="true"
                    :row-class-name="tableRowClass"
                    @sort-change='sortChange'
                    :data="posts">
                <el-table-column prop="createDt" :formatter="formatDate" label="创建时间"> </el-table-column>  
                <el-table-column prop="id" label="帖子id"></el-table-column>
                <el-table-column prop="text" width="200px" label="帖子内容" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="图片"  width="200px">
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.formatImages" :key="index">
                            <el-popover placement="left" trigger="click" width="300">
                                <img :src="item.url" width="100%" />
                                <img
                                    slot="reference"
                                    :src="item.url"
                                    :alt="item.name"
                                    style="max-height: 70px;max-width: 70px; padding: 5px"
                                />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="视频" width="150px">
                    <template slot-scope="scope">
                        <template v-if="scope.row.videos">
                            <video :src="VUE_APP_CDN_URL+scope.row.videos" class="avatar1" controls="controls"/>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="topicName" label="话题"></el-table-column>
                <el-table-column prop="gameId" :formatter="formatGameId" label="关联游戏"> </el-table-column>
                <el-table-column prop="officialNickName" label="发布账号"></el-table-column> 
                <el-table-column prop="up" sortable="custom" label="点赞数" :formatter="formatterCount"></el-table-column> 
                <el-table-column prop="discuss" sortable="custom" label="评论数" :formatter="formatterCount"></el-table-column> 
                <el-table-column prop="share" sortable="custom" label="分享数" :formatter="formatterCount"></el-table-column> 
                <el-table-column prop="hot" sortable="custom" label="热度值" :formatter="formatterCount"></el-table-column> 
                <el-table-column label="是否置顶" align="center" width="150px">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isTop"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否"
                               @change="updateTop(scope.row)">
                    </el-switch>
                </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <div style="text-align:center"><el-button size="mini" type="primary" @click="getComments(scope.row)">查看评论</el-button></div>
                        <div style="margin:10px;text-align:center"><el-button size="mini" type="primary" @click="handleEdit('编辑官方贴',scope.row)">编辑</el-button></div>
                        <div style="margin:10px;text-align:center"><el-button size="mini" type="primary" @click="flushPost(scope.row)">刷新</el-button></div>
                        <div style="text-align:center"><el-button size="mini" type="danger" :disabled="scope.row.isDelete==true"  @click="handleDelete(scope.row)">删除</el-button></div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 外层设置 分页 -->
        <div>
            <el-pagination
                @size-change="handleTotalSizeChange"
                @current-change="handleTotalCurrentChange"
                :current-page="queryData.page"
                :page-sizes="[20,50,70,100]"
                :page-size="queryData.size"
                layout="total, sizes, prev, pager, next"
                :total="totalSize">
            </el-pagination>
        </div>
        <!-- 新增 编辑dialog -->
        <div>
            <el-dialog :title="editDialogTitle"
                       center
                       :visible.sync="editDialogVisible"
                       @close="editDialogVisible=false"
                       width="800px">
                        <el-form :model="matchEditForm">
                            <el-form-item v-if="editFlag==false" label="官方账号" :label-width="labelWidth">
                                <el-select v-model="matchEditForm.officialNickName" @change="selectOfficialAccount"  placeholder="请选择/输入">
                                    <el-option
                                        v-for="item in userList"
                                        :key="item.id"
                                        :label="item.nickName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="帖子内容" :label-width="labelWidth">
                                <el-input :rows="5"  style="width: 400px" type="textarea" placeholder="请输入内容" v-model="matchEditForm.text"></el-input>
                            </el-form-item>
                            <el-form-item  label="选择素材类型" :label-width="labelWidth">
                                <template>
                                    <el-radio-group type="kind" v-model="radio" @change="changeRadio"> 
                                                <el-radio  label="0">无</el-radio>
                                                <el-radio  label="1">图片</el-radio>
                                                <el-radio  label="2">视频</el-radio>
                                    </el-radio-group>
                                </template>
                                <el-upload
                                v-if="radio==='1'"
                                :headers="headers"
                                class="upload-demo"
                                :action="uploadURL"
                                :on-success="handleImageSuccess"
                                :on-remove="handleImgRemove"
                                :before-upload="beforeImageUpload"
                                :file-list="matchEditForm.formatImages"
                                list-type="picture">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                                <!-- <img v-if="matchEditForm.images" :src="VUE_APP_CDN_URL+video.imagePath" class="avatar" alt=""/> -->
                                </el-upload>
                                <el-upload
                                v-if="radio==='2'"
                                :headers="headers"
                                class="upload-demo"
                                :action="uploadURL"
                                :show-file-list="false"
                                :on-success="handleVideoSuccess"
                                :before-upload="beforeVideoUpload"
                                >
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过5m</div>
                                <video v-if="matchEditForm.videos" :src="VUE_APP_CDN_URL+matchEditForm.videos" class="avatar1" controls="controls"/>
                                </el-upload>
                            </el-form-item>
                            <el-form-item  label="话题名称" :label-width="labelWidth">
                                <el-select v-model="matchEditForm.topicId" @change="editSelectTopic" filterable placeholder="请选择/输入">
                                    <el-option
                                        v-for="item in topics"
                                        :key="item.id"
                                        :label="item.text"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="选择游戏" :label-width="labelWidth">
                                <el-select v-model="matchEditForm.gameId" @change="editSelectGame" @clear="clearSelectGame"  clearable filterable placeholder="请选择/输入">
                                    <el-option
                                        v-for="item in gameSelectorList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="点赞基数 :"  :label-width="labelWidth">
                                <el-input-number :min="0" :max="10000" :step="1" v-model="matchEditForm.baseLike"></el-input-number>
                            </el-form-item>
                            <el-form-item label="分享基数 :"  :label-width="labelWidth">
                                <el-input-number :min="0" :max="10000" :step="1" v-model="matchEditForm.baseShare"></el-input-number>
                            </el-form-item>
                            <el-form-item  label="是否置顶：" :label-width="labelWidth">
                                    <el-radio-group   v-model="matchEditForm.isTop" > 
                                                <el-radio  :label=false>不置顶</el-radio>
                                                <el-radio  :label=true>置顶</el-radio>
                                    </el-radio-group>
                            </el-form-item>
                            <el-form-item label="选择标签" :label-width="labelWidth">
                                <el-select v-model="matchEditForm.tag" placeholder="请选择/输入">
                                    <el-option
                                        v-for="item in tagList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <div style="text-align: center;">
                                <el-button type="primary" @click="confirmEditFormDialog">确 定</el-button>
                                <el-button type="info" @click="cancleEditFormDialog">取 消</el-button>
                            </div>
                        </el-form>
            </el-dialog>
        </div>
        <div>
            <el-dialog title="详情"
                       center
                       :visible.sync="commentsDialogVisible"
                       @open="plateInfo"
                       @close="commentsDialogVisible=false"
                       :close-on-click-modal="true"
                       :show-close="true"
                       :destroy-on-close="true"
                       width="1000px">
                <h3>游戏名称:</h3> 
                            <el-select v-model="rule.gameId" disabled   placeholder="无">
                                <el-option
                                    v-for="item in gameSelectorList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select> 
                <h3>话题名称:</h3>
                    <el-input
                    type="text"
                    :rows="2"
                    placeholder="无"
                    :disabled="true"
                    v-model="rule.topicName">
                    </el-input>
                <h3>文本内容:</h3>
                    <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="无"
                    :disabled="true"
                    v-model="rule.text">
                    </el-input>
                <h3>图片信息:</h3>  
                        <span v-for="(item,index) in rule.formatImages" :key="index">
                            <img
                                    slot="reference"
                                    :src="item.url"
                                    :alt="item.name"
                                    style="max-height: 500px;max-width: 500px; padding: 5px"
                                />
                        </span> 
                <h3>视频信息:</h3>  
                            <template v-if="rule.videos">
                                <video :src="VUE_APP_CDN_URL+rule.videos" class="avatar1" controls="controls"/>
                            </template> 
                <template>
                    <h4>评论详情</h4>
                    <el-table border
                              ref="multipleTable"
                              :data="firstComments"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              lazy
                              row-key="id"
                            :load="loadSecondComments"
                            :tree-props="{hasChildren: 'hasChildren'}"
                              >
                        <el-table-column prop="id" label="帖子id"></el-table-column>
                        <el-table-column  label="头像" >
                            <template slot-scope="scope">
                                <template>
                                    <img :src="VUE_APP_CDN_URL+scope.row.officialHead" width="70px" height="70px" />
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="officialNickName" label="昵称"></el-table-column>
                        <el-table-column prop="text" width="200px" label="内容" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="level" label="级别"></el-table-column>
                        <el-table-column  prop="createDt" :formatter="formatDate" label="创建时间"> </el-table-column>
                         <el-table-column prop="up"  label="点赞数" :formatter="formatterCount" > </el-table-column>
                        <el-table-column label="操作" align="center" width="100px">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" :disabled="scope.row.isDelete==true"  @click="handleDelete(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>


                    </el-table>
                    <div>
                        <el-pagination
                                @size-change="innerSizeChange"
                                @current-change="innerCurrentChange"
                                :current-page="innerQueryData.page"
                                :page-sizes="[20,50,70,100]"
                                :page-size="innerQueryData.size"
                                layout="total, sizes, prev, pager, next"
                                :total="innerTotalSize">
                        </el-pagination>
                    </div>
                </template>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        gameRunningList,
        searchOfficialPosts,
        addOfficialPost,
        editOfficialPost,
        changeOfficialDelete,
        changeOfficialTop,
        searchFirstPostComments,
        searchSecondPostComments,

        allOfficialUser,
        openTopic,
        flushPostMQ

    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "OfficialPost",
        data () {
            return {
                // inject:['reload'],
                headers: {},
                url:'',
                loading: false,
                labelWidth: '200px',
                editDialogVisible: false,
                editFlag:false,
                editDialogTitle: '',
                //标签List
                tagList:[
                    {id:0,name:"无"},
                    {id:1,name:"火爆"},
                    {id:2,name:"精选"}
                ],
                //素材类型标志位
                radio:'0',
                //上传图片路径
                uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
                //编辑的数据对象
                matchEditForm: {
                    "id": null,
                    "gameId": null,
                    "text":null,
                    "images":null,
                    "videos":null,
                    "topicId":null,
                    "topicName":null,
                    "isTop":null,
                    "officialNickName":null,
                    "officialHead":null,
                    "officialTitle":null,
                    "did":null,
                    "baseShare":null,
                    "baseLike":null,
                    "discuss":null,
                    "hot":null,
                    "up":null,
                    "share":null,
                    "tag":null,
                    "isOfficial":true,
                    "isDelete":false,
                    "level":1,
                    "replyDid":null,
                    "formatImages":[]
                },
                //列表数据
                posts: [
                ],
                //外层列表数量
                totalSize:0,
                //内层列表数量
                innerTotalSize:0,
                //一级评论列表数据
                firstComments: [
                ],
                //二级评论列表数据
                secondComments: [
                ],
                //每行数据
                rule:{},
                //外层搜索查询条件
                queryData:{
                    "officialNickName":null,
                    "gameId": null,
                    "topicName":null,
                    "text":null,
                    "page":1,
                    "size":20,
                    "orders":"createDt desc ",
                    "isDelete":false,
                    "startDt":null,
                    "endDt":null,
                    "timeDate":[],
                    "isPic":null,
                    "isVideo":null
                },
                //外层分页
                pagination:{
                    size:10,
                    pageNumber:1,
                },
                //内层查询条件 page size
                innerQueryData:{
                    "page":1,
                    "size":20
                },
                games:[],
                cateList:[],
                //游戏选品中游戏列表下拉框数据 固定的
                gameSelectorList: [], 
                //内部弹窗可见
                commentsDialogVisible:false,
                //官方账号信息
                userList:[],
                //全部topic信息
                topics:[],
                //查询日期区间
                searchDateRange:[],
                pickerMinDate:'',
                pickerOptions: {
                    onPick: (time) => {
                        // this.pickerMinDate = time.minDate;
                        if(time.minDate && !time.maxDate){
                            this.pickerMinDate=time.minDate;  //将第一次选中值保存
                        }
                        if(time.maxDate){
                            this.pickerMinDate=null;
                        }
                    },
                    disabledDate:(time)=> {
                        if (this.pickerMinDate) {
                            const day1 =  7 * 24 * 3600 * 1000;
                            let maxTime = this.pickerMinDate.getTime() + day1;
                            let minTime = this.pickerMinDate.getTime() - day1;
                            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()+24 * 3600 * 1000
                        }else{
                            return time.getTime() > Date.now()+24 * 3600 * 1000
                        }
                    }
                },
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                BooleanOptions:[
                    {value:true,label:"是"},
                    {value:false,label:"否"}
                ]
            }
        },
        created () {
            this.headers ={Authorization : this.$store.state.user.token};
            gameRunningList().then(resp=>{
                 this.gameSelectorList=resp.data.info;
             });
             this.searchPosts();
             allOfficialUser().then(resp => {
                    this.userList = resp.data.info;
             });
             openTopic().then(resp=>{
                 this.topics=resp.data.info;
             })
        },
        methods:{
            //格式化游戏id
            formatGameId: function(row, column,cellValue) {
                var temp="无"
                    this.gameSelectorList.forEach( item => {
                        if(item.id===cellValue){ 
                             temp=item.name;
                             
                        }
                    })
                    return temp
            },
            //带百分数的格式化
            formatterPercent: function (row, column, cellValue){
                if(cellValue===null){
                    return "0%";
                }else{
                    return (cellValue*100).toFixed(2)+"%";
                }
                
            },
            //默认数字的格式化 赋值默认值为0
            formatterCount: function (row, column, cellValue){
                if(cellValue===null){
                    return 0;
                }else{
                    return cellValue;
                }
                
            },
            //格式化日期
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            //根据游戏id获取游戏名称
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            getRowKeys(row){
                return row.id
            },
            // 总条数修改
            handleTotalSizeChange(newSize) {
                this.queryData.size = newSize;
                this.searchPosts();
            },
            //总页数跳转
            handleTotalCurrentChange(newPage) {
                this.queryData.page = newPage;
                this.searchPosts();
            },
            //下拉框同时赋值两个参数
            editSelectGame(id){
                    let dir = this.gameSelectorList.find((item) => item.id === id);
                    this.matchEditForm.gameId=dir.id;
            },
            editSelectTopic(id){
                    let dir = this.topics.find((item) => item.id === id);
                    this.matchEditForm.topicId=dir.id;
                    this.matchEditForm.topicName=dir.text;
                    //如果关联话题不为空 同时修改对应关联游戏名称
                    if(dir.gameId > 0){
                        this.matchEditForm.gameId=dir.gameId
                    }
                    if(dir.gameId == 0){
                        this.matchEditForm.gameId=null;
                    }
            },
            //下拉框同时清除两个参数
            clearSelectGame(){
                console.log(this.matchEditForm);
                this.matchEditForm.gameId=null;
            },
            //下拉框选择官方账号
            selectOfficialAccount(id){
                let dir = this.userList.find((item) => item.id == id);
                //重复赋值selecter绑定参数 否则会使用传入id作为nickName
                this.matchEditForm.officialNickName=dir.nickName;
                this.matchEditForm.officialHead=dir.head;
                //设置title
                this.matchEditForm.officialTitle=dir.title;
                this.matchEditForm.did=dir.did;
                //将did设置到replyId 方便客户端使用参数
                this.matchEditForm.replyDid=dir.did;
            },
            //单元框切换清空操作
            changeRadio(value){
                console.log("======切换标签清空全部数据list======="+value)
                //清空所有list
                this.matchEditForm.images=null;
                this.matchEditForm.videos=null;
                this.matchEditForm.formatImages=[];
            },
            //图片上传相关
            handleImageSuccess(data) {
                // console.log(data)
                var temp={name:null,url:null,postUrl:null};
                var url=data.info
                var array=url.split('/');
                // console.log(array)
                temp.name=array[array.length-1];
                //这里拼接对象进去   获取展示数据的时候可能需要解析数组 提交数据的时候需要组合数组
                temp.url=process.env.VUE_APP_CDN_URL +url
                temp.postUrl=url;
                // console.log(temp)
                this.matchEditForm.formatImages.push(temp);
                console.log(this.matchEditForm.formatImages)
            },
            beforeImageUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.png' || data.name.substring(data.name.lastIndexOf('.')) === '.jpg';
                const size = data.size < 1024 * 1024 * 5;
                if (!type) {
                    this.$message.error('上传图片只能是png,jgp格式!');
                }
                if (!size) {
                    this.$message.error('上传图片大小不能超过500MB!');
                }
                return type && size;
                },
            //删除上传列表图片
            handleImgRemove(file){
                console.log(file)
                // 1.获取将要删除图片的临时路径
                const name = file.name
                // 2.从pics数组中，找到图片对应的索引值
                const i = this.matchEditForm.formatImages.findIndex(x => x.name === name)
                // 3.调用splice方法，移除图片信息
                this.matchEditForm.formatImages.splice(i, 1)
            },
            beforeVideoUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.mp4';
                const size = data.size < 1024 * 1024 * 5;
                if (!type) {
                    this.$message.error('上传视频只能是mp4格式!');
                }
                if (!size) {
                    this.$message.error('上传视频大小不能超过5m!');
                }
                return type && size;
            },
            handleVideoSuccess(data) {
                this.matchEditForm.videos = data.info;
                },
            //修改排序顺序
            sortChange(param){
                // console.log(param);
                if(param.prop == null ){
                    return;
                }else {
                    if( param.order == null){
                        return;
                    }else {
                        // console.log(param.order);
                        this.queryData.orders=param.prop+" "+param.order+",createDt desc ";
                        // console.log(this.queryData.orders)
                    }
                }
                this.searchPosts();
            },
            //-------------------------------------------相关方法
            flushPost(row){
                flushPostMQ(row.did,row.id);
            },
            //查询官方贴方法
            searchPosts:function(){
                //判断是否选择了日期
                if(this.queryData.timeDate.length>0){
                    var tempDate=this.queryData.timeDate;
                    this.queryData.startDt=tempDate[0];
                    this.queryData.endDt=tempDate[1];
                }
                // console.log(this.queryData)
                searchOfficialPosts(this.queryData).then(resp=>{
                    //设置images格式
                    let listBefore=resp.data.info.list;
                    listBefore.forEach(item=> {
                        //图片处理
                        // console.log(item.images);
                        item.formatImages=[];
                        if(item.images!=null){
                            // let tempArrayImages=JSON.parse(item.images);
                            //使用逗号分隔字符串截取图片信息
                            var tempArrayImages= new Array(); //定义一数组
                            tempArrayImages=item.images.split("，"); //字符分割 这里使用的是中文逗号
                            // console.log(tempArrayImages)
                            if(tempArrayImages.length>0){
                                tempArrayImages.forEach(imagesUrl=>{
                                    var temp={name:null,url:null,postUrl:null};
                                    var url=imagesUrl;
                                    var array=url.split('/');
                                    temp.name=array[array.length-1];
                                    temp.url=process.env.VUE_APP_CDN_URL +url;
                                    temp.postUrl=url;
                                    item.formatImages.push(temp);
                                    // console.log(temp)
                                })
                            }
                        }
                        
                    })
                    // console.log(listBefore)
                    this.posts = listBefore;
                    this.totalSize=resp.data.info.totalElements;
                    // this.reload()
                })
            },
            //新增板块和 编辑板块 按钮操作方法
            handleEdit: function(title,row){
                // console.log(this.matchEditForm)
                this.matchEditForm = {
                    "id": null,
                    "gameId": null,
                    "text":null,
                    "images":null,
                    "videos":null,
                    "topicId":null,
                    "isTop":true,
                    "officialNickName":null,
                    "officialTitle":null,
                    "officialHead":null,
                    "did":null,
                    "baseShare":0,
                    "baseLike":0,
                    "discuss":0,
                    "hot":0,
                    "up":0,
                    "share":0,
                    "tag":null,
                    "isOfficial":true,
                    "isDelete":false,
                    "basePv":0,
                    "level":1,
                    "replyDid":null,
                    "formatImages":[]
                };
                this.editDialogTitle = title;
                this.editDialogVisible = true;
                this.editFlag=false;
                this.radio='1';
                if(row){
                    this.matchEditForm = {
                        "id": row.id,
                        "gameId": row.gameId,
                        "text":row.text,
                        "images":row.images,
                        "videos":row.videos,
                        "topicId":row.topicId,
                        "isTop":row.isTop,
                        "officialNickName":row.officialNickName,
                        "officialTitle":row.officialTitle,
                        "officialHead":row.officialHead,
                        "did":row.did,
                        "baseShare":row.baseShare,
                        "baseLike":row.baseLike,
                        "discuss":row.discuss,
                        "hot":row.hot,
                        "up":row.up,
                        "share":row.share,
                        "tag":row.tag,
                        "isOfficial":row.isOfficial,
                        "isDelete":row.isDelete,
                        "level":row.level,
                        "basePv":row.basePv,
                        "replyDid":row.replyDid,
                        //格式化images
                        "formatImages":[],
                        "topicName":row.topicName,
                        
                    };
                    //设置formatImages 
                        if(row.images!=null){
                            // let tempArrayImages=JSON.parse(item.images);
                            //使用逗号分隔字符串截取图片信息
                            var tempArrayImages= new Array(); //定义一数组
                            tempArrayImages=row.images.split("，"); //字符分割 这里使用的是中文逗号
                            if(tempArrayImages.length>0){
                                tempArrayImages.forEach(imagesUrl=>{
                                    var temp={name:null,url:null,postUrl:null};
                                    var url=imagesUrl;
                                    var array=url.split('/');
                                    temp.name=array[array.length-1];
                                    temp.url=process.env.VUE_APP_CDN_URL +url;
                                    temp.postUrl=url;
                                    this.matchEditForm.formatImages.push(temp);
                                })
                            }
                        }
                    this.editFlag=true;
                    //修改编辑标志位
                    if(row.images!=null){
                        this.radio='1';
                    }else if(row.videos!=null){
                        this.radio='2';
                    }else{
                        this.radio='0';
                    }

                }
            },
            
            // 修改是否可见开关开启关闭 方法
            handleDelete: function (row) {
                this.$confirm('确认是否删除?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    row.isDelete=true;
                    changeOfficialDelete(row.did,row.id,row.isDelete).then(resp=>{
                        if (resp.data.status==0){
                            this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                        }else{
                            //恢复开关键
                            row.isDelete=false;
                            this.$message({
                                message: "操作失败",
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                })
            },
            // 修改是否置顶开关开启关闭 方法
            updateTop(row){
                changeOfficialTop(row.did,row.id,row.isTop).then(resp=>{
                    if (resp.data.status==0){
                        this.$message({
                            message: "操作成功",
                            type: 'success'
                        });
                    }else{
                        //恢复开关键
                        row.isTop=!row.isTop;
                        this.$message({
                            message: "操作失败",
                            type: 'error'
                        });
                    }
                });
            },
            tableRowClass: function(row){
                if(row.rowIndex%2===1){
                    return 'row_odd_class'
                }
                return ''
            },
            // 新增和编辑和复制板块使用的数据
            confirmEditFormDialog: function(){
                     //组合images图像
                    if(this.matchEditForm.formatImages.length>0){
                        let tempImages=[];
                        this.matchEditForm.formatImages.forEach(item=>{
                            tempImages.push(item.postUrl);
                        })
                        //这里使用的是中文逗号 是个坑 客户端定的
                        var arrJoinString = tempImages.join('，');
                        // this.matchEditForm.images=JSON.stringify(tempImages);
                        this.matchEditForm.images=arrJoinString;
                    }
                // console.log(this.matchEditForm)
                if(this.editFlag){
                    editOfficialPost(this.matchEditForm).then(resp=>{
                        if (resp.data.status===0){
                        this.editDialogVisible = false;
                        setTimeout(this.searchPosts(),"10000");
                        }
                    })
                }else{
                    //=================================================设置测试信息
                    addOfficialPost(this.matchEditForm).then(resp=>{
                        if (resp.data.status===0){
                        this.editDialogVisible = false;
                        setTimeout(this.searchPosts(),"10000");
                        }
                    })
                }
            },
            //取消编辑窗口  进行初始化
            cancleEditFormDialog () {
                this.editDialogVisible=false;
                this.radio='0'
            },
            //查询评论部分
            getComments(row){
                this.rule=row;
                this.gameSelectorTemp();
                //展示dialog
                this.commentsDialogVisible=true;
            },
            //待处理
            gameSelectorTemp() {
                // console.log(this.innerQueryData)
                searchFirstPostComments(this.rule.did,this.rule.id,this.innerQueryData.page,this.innerQueryData.size).then(resp=>{
                    //处理插入子节点标志位
                    this.innerTotalSize=resp.data.info.totalElements;
                    let arrays=resp.data.info.list;
                    //全部设置有子节点 树形结构用
                    arrays.forEach(item => {item.hasChildren=true})
                    this.firstComments=arrays; 
                });
            },
            //加载二级评论方法
            loadSecondComments(tree, treeNode, resolve){
                // console.log(tree)
                searchSecondPostComments(tree.did,tree.id).then(resp=>{
                    // console.log(resp.data.info);
                    resolve(resp.data.info)
                })
            }, 
            
            innerSizeChange(newSize){
                this.innerQueryData.size=newSize;
                this.gameSelectorTemp()
            },
            innerCurrentChange(newPage){
                this.innerQueryData.page=newPage;
                this.gameSelectorTemp()
            },
            plateInfo(){
                return this.rule;
            },
        },

        mounted () {  
            //这里获取video地址
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
            this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        }
    }
</script>
<style scoped>

</style>
